(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Parse the URL query parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Check if 'art' parameter exists
    if (urlParams.has('art')) {
      // Get the value of the 'art' parameter and properly decode it
      const artValue = decodeURIComponent(urlParams.get('art'));

      // Find the input element
      const artInput = document.getElementById('ContactForm-art');

      // If the input element exists, set its value
      if (artInput) {
        artInput.value = artValue;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get the current URL
    const url = new URL(window.location.href);

    // Check if there's an 'art' parameter in the query string
    if (url.searchParams.has('art')) {
      // Get the value of the 'art' parameter
      const artValue = url.searchParams.get('art');

      // Find the Art Inquired input field
      const artInput = document.querySelector('#art');
      if (artInput) artInput.value = artValue;
    }

    // After a successful send, bring the thank-you message into view
    const thanks = document.querySelector('#cs-contact .cs-thanks');
    if (thanks) {
      thanks.scrollIntoView({ block: 'start' });
      thanks.querySelector('.cs-title')?.focus({ preventScroll: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-slideshow"] && !Shopify.designMode) return;
  try {
    
class Slideshow2 {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('.cs-slide2'));
    this.captions = Array.from(root.querySelectorAll('.cs-caption'));
    this.nextButton = root.querySelector('.cs-slideshow-next');
    this.prevButton = root.querySelector('.cs-slideshow-prev');
    this.currentIndex = 0;
    this.isMoving = false;
    this.autoPlayInterval = Number(root.dataset.autoplayInterval) || 5000;
    this.autoPlayTimer = null;

    if (this.slides.length > 0) {
      this.init();
    }
  }

  init() {
    this.nextButton?.addEventListener('click', () => this.moveSlide('next'));
    this.prevButton?.addEventListener('click', () => this.moveSlide('prev'));

    // Hovering or focusing anywhere in the banner pauses autoplay
    this.root.addEventListener('mouseenter', () => this.pauseAutoPlay());
    this.root.addEventListener('mouseleave', () => this.startAutoPlay());
    this.root.addEventListener('focusin', () => this.pauseAutoPlay());
    this.root.addEventListener('focusout', () => this.startAutoPlay());

    this.startAutoPlay();
  }

  moveSlide(direction, isAuto = false) {
    if (this.isMoving || this.slides.length <= 1) return;

    this.isMoving = true;

    if (!isAuto) {
      this.restartAutoPlay();
    }

    this.setActive(this.currentIndex, false);

    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    } else {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    }

    this.setActive(this.currentIndex, true);
    setTimeout(() => {
      this.isMoving = false;
    }, 600); // match this with CSS transition duration
  }

  setActive(index, active) {
    const slide = this.slides[index];
    const caption = this.captions[index];

    slide.classList.toggle('active', active);
    active ? slide.removeAttribute('aria-hidden') : slide.setAttribute('aria-hidden', 'true');

    if (caption) {
      caption.classList.toggle('active', active);
      caption.hidden = !active;
    }
  }

  startAutoPlay() {
    this.pauseAutoPlay();
    this.autoPlayTimer = setInterval(() => {
      this.moveSlide('next', true);
    }, this.autoPlayInterval);
  }

  pauseAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }

  restartAutoPlay() {
    this.pauseAutoPlay();
    this.startAutoPlay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('slide-gallery-2236');
  if (root) new Slideshow2(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
